import { useEffect, useRef, useState } from "react";
import { ISearchBox } from "@fluentui/react";
import { IRazonModeloRequest, IRazonModeloDTO } from "../../../../Interfaces/auxiliar/IRazonModelo";
import { IPaginacionComponent } from "../../../../Interfaces/filter";
import RazonModeloService from "../../../../services/auxiliar/RazonModeloService";
import { IPaginationV2 } from "../../../../Interfaces/base/ITable";


export type keyType = "turnoKey" | "razonKey" | "ubicacionKey" | "equipoKey" | "estadoKey" | "tipoEquipoKey" | "regionKey"
export type textType = "tuernoText" | "razonText" | "ubicacionText" | "equipoText" | "estadoText" | "tipoEquipoText" | "regionText"

export interface IFilter2 {
   turnoKey: string,
   tuernoText: string
   razonKey: string,
   razonText: string
   ubicacionKey: string,
   ubicacionText: string
   equipoKey: string,
   equipoText: string,
   estadoKey: string,
   estadoText: string,
   tipoEquipoKey: string,
   tipoEquipoText: string,
   regionKey: string,
   regionText: string,

}

const initialFilter2: IFilter2 = {
   turnoKey: "",
   tuernoText: "",
   razonKey: "",
   razonText: "",
   ubicacionKey: "",
   ubicacionText: "",
   equipoKey: "",
   equipoText: "",
   estadoKey: "",
   estadoText: "",
   tipoEquipoKey: "",
   tipoEquipoText: "",
   regionKey: "",
   regionText: ""
}

export interface IT {
   key: keyType, keyValue: string, text: textType, textValue: string
}

export const UseRazonModelo = () => {
   const [loading, setLoading] = useState<boolean>(false)
   const [items, setItems] = useState<IRazonModeloDTO[]>([])
   const onChangeSearch = useRef<ISearchBox>(null);
   const [control, setControl] = useState(true);
   const [filter2, setFilter2] = useState<IFilter2>({ ...initialFilter2 });
   const [filter, setFilter] = useState<IRazonModeloRequest>({
      skip: 0,
      take: 50,
   });

   const initial: IRazonModeloRequest = {
      skip: 0,
      take: 50,
   }

   const _onkeyUpSearchTable = (
      event: React.KeyboardEvent<HTMLInputElement>
   ) => {
      let { value } = event?.target as HTMLInputElement;
      setFilter({ ...filter, search: value });
   };

   const onChangeTake = (value: number) => {
      setFilter({ ...filter, take: value })
      setControl(true)
   };
   const onSkip = (value: number) => {
      const realSkip = (value * filter.take) - filter.take
      setFilter({ ...filter, skip: realSkip })
      setControl(true)
   };

   const setRazonId = (razonId: string) => {
      setFilter({
         ...filter,
         razonId: razonId
      });
   };
   const handleResetUpdate = (razonId?: string) => {
      setFilter({
         ...initial,
         razonId: razonId
      });
      setControl(true)
   };
   const [pagination, setPagination] = useState<IPaginationV2>({
      currentPage: 0,
      total: 0,
      pageSize: 0,
      skip: 0,
      take: 50,
      onPageChange: function (value: number): void {
      },
      onSizeChange: function (value: number): void {
      }
   })

   const getRazonModelo = () => {
      setLoading(true)
      RazonModeloService.TablaRazonModelo(filter).then((res) => {
         // console.log("datos", res)
         const pag: IPaginationV2 = {
            currentPage: res.data.page,
            total: res.data.total,
            pageSize: res.data.pages,
            onPageChange: onSkip,
            skip: filter.skip,
            take: filter.take,
            onSizeChange: onChangeTake
         };
         setPagination(pag)
         setLoading(false)
         setItems(res.data.items)
      }).catch((e: any) => {
         setLoading(false)
      })
   };

   const onChangeComboFilter = ({ key, keyValue, text, textValue }: IT) => {
      setFilter2((prevState) => ({
         ...prevState,
         [key]: keyValue,
         [text]: textValue,
      }));
   };

   const buscar = () => {
      setFilter({
         skip: 0,
         take: 50,
         razonId: filter2.razonKey !== "" ? filter2.razonKey : undefined,
         tipoEquipoId: filter2.tipoEquipoKey !== "" ? filter2.tipoEquipoKey : undefined,
      });
      setControl(true);
   };


   const resetFilter2 = () => {
      setFilter2({ ...initialFilter2 });
      setFilter({
         search: "",
         skip: 0,
         take: 50,
      });
      setControl(true);
   };

   useEffect(() => {
      if (control) {
         getRazonModelo();
         setControl(false);
      }
   }, [control]);

   return {
      items,
      filter,
      setFilter,
      loading,
      pagination,
      getRazonModelo,
      handleResetUpdate,
      onChangeTake,
      _onkeyUpSearchTable,
      onChangeSearch,
      setRazonId,
      onChangeComboFilter,
      filter2,
      setFilter2,
      resetFilter2,
      buscar
   }
}

